import React from 'react';
import middleware from '../../Api/Middleware';
import { ButtonBlue, ButtonLightGrey } from '../../HouseStyle/Components/Buttons';

const Step4Review = ({ data, onSubmit, onPrev }) => {
    const getDisplayValue = (value, defaultText = '-') => {
        return value || defaultText;
    };

    const getCombinedPhoneNumber = () => {
        if (data.phone_number_country_code && data.phone_number) {
            return `+${data.phone_number_country_code}${data.phone_number.replace(/\s+/g, '')}`;
        }
        return getDisplayValue(data.phone_number);
    };

    const handleSubmit = () => {
        // Combine phone number and country code for API
        const payload = {
            ...data,
            phone_number: getCombinedPhoneNumber()
        };
        onSubmit(payload);
    };

    const handlePrev = () => {
        onPrev();
    };

    // Format display values
    const getBranchDisplay = (value) => {
        switch (value) {
            case '0': return 'Detailhandel';
            case '1': return 'Horeca';
            default: return '-';
        }
    };

    const getTaxDisplay = (value) => {
        switch (value) {
            case 'high': return 'Hoog (21%)';
            case 'reduced': return 'Laag (9%)';
            case 'zero': return 'Uitgesloten van BTW (0%)';
            default: return '-';
        }
    };

    const getB2BDisplay = (value) => {
        switch (value) {
            case '0': return 'Ja - Business to Business';
            case '1': return 'Nee - Business to Consumer';
            case '2': return 'Beide - B2B en B2C';
            default: return '-';
        }
    };

    return (
        <div className="step-container">
            <div className="step-content-area">
                <div className="review-content">
                    <div className="step-title">Overzicht</div>
                    <div className="review-section">
                        <div className="review-grid">
                            <div className="review-column">
                                <div className="review-item">
                                    <strong>Bedrijfsnaam</strong>
                                    <span>{getDisplayValue(data.company_name)}</span>
                                </div>

                                <div className="review-item">
                                    <strong>BTW nummer</strong>
                                    <span>{getDisplayValue(data.vatnumber)}</span>
                                </div>
                            </div>

                            <div className="review-column">
                                <div className="review-item">
                                    <strong>KVK nummer</strong>
                                    <span>{getDisplayValue(data.cocnumber)}</span>
                                </div>

                                <div className="review-item">
                                    <strong>IBAN nummer</strong>
                                    <span>{getDisplayValue(data.iban)}</span>
                                </div>
                            </div>
                        </div>

                        <div className="divider"></div>

                        <div className="review-grid">
                            <div className="review-column">
                                <div className="review-item">
                                    <strong>Postcode</strong>
                                    <span>{getDisplayValue(data.postal_code)}</span>
                                </div>

                                <div className="review-item">
                                    <strong>Straat</strong>
                                    <span>{getDisplayValue(data.street_name)}</span>
                                </div>
                            </div>

                            <div className="review-column">
                                <div className="review-item">
                                    <strong>Huisnummer</strong>
                                    <span>{getDisplayValue(data.house_number)} {getDisplayValue(data.addition, '')}</span>
                                </div>

                                <div className="review-item">
                                    <strong>Stad</strong>
                                    <span>{getDisplayValue(data.city)}</span>
                                </div>
                            </div>
                        </div>

                        <div className="divider"></div>

                        <div className="review-grid">
                            <div className="review-column">
                                <div className="review-item">
                                    <strong>Algemene telefoon nummer</strong>
                                    <span>
                                        {getCombinedPhoneNumber()}
                                    </span>
                                </div>
                            </div>

                            <div className="review-column">
                                <div className="review-item">
                                    <strong>Algemene e-mail</strong>
                                    <span>{getDisplayValue(data.email)}</span>
                                </div>
                            </div>
                        </div>

                        <div className="divider"></div>

                        <div className="review-grid">
                            <div className="review-column">
                                <div className="review-item">
                                    <strong>Branche</strong>
                                    <span>{getBranchDisplay(data.company_branch)}</span>
                                </div>

                                <div className="review-item">
                                    <strong>Standaard BTW tarief</strong>
                                    <span>{getTaxDisplay(data.tax)}</span>
                                </div>
                            </div>

                            <div className="review-column">
                                <div className="review-item">
                                    <strong>B2B / B2C</strong>
                                    <span>{getB2BDisplay(data.b2b_b2c)}</span>
                                </div>

                                <div className="review-item">
                                    <strong>Betaal termijn factuur (aantal dagen)</strong>
                                    <span>{getDisplayValue(data.payment_term)} dagen</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="divider"></div>

                    {/* Logo Review Section */}
                    <div className="logo-review-section">
                        <div className="logo-review-container">
                            <div className="logo-review-item">
                                <h3>Bedrijfslogo kleur</h3>
                                <div className="logo-preview">
                                    {data.logo && data.logo ? (
                                        <img
                                            src={data.logo}
                                            alt="Company Logo"
                                            style={{
                                                maxWidth: '100%',
                                                maxHeight: '100%',
                                                objectFit: 'contain'
                                            }}
                                        />
                                    ) : (
                                        <div className="logo-placeholder">
                                            Geen logo geüpload
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="logo-review-item">
                                <h3>Bedrijfslogo zwart/wit</h3>
                                <div className="logo-preview">
                                    {data.blackwhite_logo && data.blackwhite_logo ? (
                                        <img
                                            src={data.blackwhite_logo}
                                            alt="Company Logo B&W"
                                            style={{
                                                maxWidth: '100%',
                                                maxHeight: '100%',
                                                objectFit: 'contain'
                                            }}
                                        />
                                    ) : (
                                        <div className="logo-placeholder">
                                            Geen zwart-wit logo geüpload
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="divider"></div>

                    {/* Colors Review Section */}
                    <div className="colors-review-section">
                        <h3>5 kleuren</h3>
                        <div className="color-swatches">
                            {data.selectedColors && data.selectedColors.map((color, index) => (
                                <div key={index} className="color-swatch-container">
                                    <div
                                        className="color-swatch"
                                        style={{ backgroundColor: color }}
                                    />
                                    <div className="color-hex">
                                        {color}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Font Review Section */}
                    <div className="font-review-section">
                        <div className="review-item">
                            <strong>Font</strong>
                            <span>{getDisplayValue(data.font)}</span>
                        </div>
                    </div>
                </div>
            </div>
            {/* Navigation Buttons */}
            <div className="form-actions">
                <ButtonLightGrey
                    onClickFunction={handlePrev}
                    text="Terug"
                />
                <ButtonBlue
                    onClickFunction={handleSubmit}
                    text="Afronden"
                />
            </div>
        </div>
    );
};

export default Step4Review;